(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('ApprovalsController', ApprovalsController);

  /* ngInject */
  function ApprovalsController(approvalService, sessionService) {
    const vm = this;

    vm.approvals = [];
    vm.status = 'all';

    activate();

    function activate() {
      getApprovals();
    }

    function getApprovals() {
      var params = {};

      if (vm.status != 'all') {
        params['status'] = vm.status;
      }

      approvalService(sessionService.getAuthToken()).query(params, response => vm.approvals = response);
    }
  }
})();
